import HttpService from '../http/HttpService';
import { SystemFiltersEndpoint } from '../endpoints/modules/SystemFiltersEndpoint';
import VcomProvider from '../../VcomProvider';

async function loadFilters() {
  const response = await HttpService.get(
    SystemFiltersEndpoint.LOAD,
  );
  return response.data;
}

function setActiveFilter(filters, defaultFilters) {
  const systemFilters = VcomProvider.systemFilters.map((filter) => filter.ID_SAF_TF_TEILMENGE);
  return filters
    .flatMap((filter) => filter.groupFilters)
    .filter((groupFilter) => systemFilters.includes(groupFilter.ID_SAF_TF_TEILMENGE.toString())
      || systemFilters.includes(groupFilter.ID_SAF_TF_TEILMENGE))
    ?? defaultFilters;
}

function resetSystemFilters() {
  return HttpService.get(
    SystemFiltersEndpoint.RESET,
  );
}

const SystemFilterService = {
  resetSystemFilters,
  loadFilters,
  setActiveFilter,
};

export default SystemFilterService;
